import { NativeCurrency, Token } from '@kodiak-finance/sdk-core'
import { nativeOnChain } from 'constants/tokens'
import { useConnection } from 'hooks/useConnection'
import { useMemo } from 'react'

export default function useNativeCurrency(): NativeCurrency | Token {
  const { chainId } = useConnection()
  return useMemo(() => nativeOnChain(chainId), [chainId])
}
